import { cn } from '../../utils/cn';

type UnreadBadgeProps = {
  count?: number;
  className?: string;
};

export function UnreadBadge({ count, className }: UnreadBadgeProps) {
  if (count == null || count <= 0) return null;

  return (
    <div
      className={cn(
        'relative w-6 h-6 bg-red-500 rounded-full flex-shrink-0',
        className,
      )}
    >
      <p className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
        text-[11px] text-white text-start font-normal whitespace-pre-line">
        {count > 99 ? '99+' : count}
      </p>
    </div>
  );
}
